import "../../css/widgets/widgets.css";
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { duotone } from '@fortawesome/fontawesome-svg-core/import.macro';
import { Row, Col } from 'react-bootstrap';
import React, { useState, useEffect } from 'react';

function IncomingCalls(props) {

    const { t } = useTranslation();
    const [all, setAll] = useState(0);
    const [attended, setAttended] = useState(0);
    const [missed, setMissed] = useState(0);
    const [groupAll, setGroupAll] = useState(0);
    const [groupAttended, setGroupAttended] = useState(0);
    const [groupMissed, setGroupMissed] = useState(0);

    useEffect(() => {
        let incomingcalls = props.calls.filter(x => x.interlocutor !== null && x.incoming);
        setAll(incomingcalls.length)
        setAttended(incomingcalls.filter(x => x.connected).length);
        setMissed(incomingcalls.filter(x => !x.connected).length);
        setGroupAll(incomingcalls.filter(x => x.groupId > -1).length)
        setGroupAttended(incomingcalls.filter(x => x.connected && x.groupId > -1).length);
        setGroupMissed(incomingcalls.filter(x => !x.connected && x.groupId > -1).length);
        setGroupMissed(incomingcalls.filter(x => !x.connected && x.groupId > -1).length);
        return () => {
            // component unmounts
        };
    }, [props.calls]);


    return (
        <div className={"card card-flush overflow-hidden"} >
            <div className="card-header ">
                <h3 className="card-title align-items-start flex-column text-primary">
                    <span className="card-label fw-bold text-primary"><FontAwesomeIcon icon={duotone("phone-arrow-down-left")} /> {t("incomingcalls")}</span>

                </h3>
                <div className="card-toolbar">
                </div>
            </div>
            <div className="card-body" style={{ "padding": "0rem 2.25rem" }}>
                <Row>
                    <Col> <span className="fs-3 fw-bold text-primary">{t("all")}</span></Col>
                    <Col> <span className="fs-3 fw-bold text-primary">{t("groupcalls")}</span></Col>
                </Row>
                <Row>
                    <Col >
                        <div className="fs-2hx fw-bold text-gray-800">{all}</div>
                        <div className="fs-5 fw-semibold text-gray-400 ">{t("total")}</div>
                    </Col>
                    <Col >
                        <div className="fs-2hx fw-bold text-success">{attended}</div>
                        <div className="fs-5 fw-semibold text-gray-400 ">{t("attended")}</div>
                    </Col>
                    <Col >
                        <div className="fs-2hx fw-bold text-danger">{missed}</div>
                        <div className="fs-5 fw-semibold text-gray-400 ">{t("missed")}</div>
                    </Col>
                    <Col>
                        <div className="fs-2hx fw-bold text-gray-800">{groupAll}</div>
                        <div className="fs-5 fw-semibold text-gray-400 ">{t("total")}</div>
                    </Col>
                    <Col>
                        <div className="fs-2hx fw-bold text-success">{groupAttended}</div>
                        <div className="fs-5 fw-semibold text-gray-400 ">{t("attended")}</div>
                    </Col>
                    <Col>
                        <div className="fs-2hx fw-bold text-danger">{groupMissed}</div>
                        <div className="fs-5 fw-semibold text-gray-400 ">{t("missed")}</div>
                    </Col>
                </Row>
            </div>
        </div>

    )
}
export default IncomingCalls;